import React, { useState } from "react";
import { TextField } from "@mui/material";
import { Controller, ControllerProps } from "react-hook-form";
import dayjs from "dayjs";
import { TimePicker as MUITimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, parseISO } from "date-fns";

interface TimePickerProps {
  name: string;
  label: string;
  control: any;
  setValue: any;
  disabled?: boolean;
  rules?: ControllerProps["rules"];
  defaultValue?: string;
  disableOpenPicker?: boolean;
}

const TimePicker: React.FC<TimePickerProps> = ({
  label,
  name,
  setValue,
  control,
  disableOpenPicker,
  disabled,
  rules,
  defaultValue,
}) => {
  const [timeValue, setTimeValue] = useState<Date | null>(
    defaultValue ? parseISO(`2020-01-01 ${defaultValue}`) : null,
  );

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={() => {
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MUITimePicker
              disableOpenPicker={disableOpenPicker}
              ampm={false}
              openTo="hours"
              views={["hours", "minutes"]}
              inputFormat="HH:mm"
              mask="__:__"
              label={label}
              value={timeValue}
              onChange={(newValue, text) => {
                setTimeValue(newValue);
                let safeNewValue = text;

                if (newValue) {
                  const newValueInDateFormat = dayjs(newValue).toDate();
                  const isNewValueValid =
                    // eslint-disable-next-line no-self-compare
                    newValueInDateFormat.getTime() ===
                    newValueInDateFormat.getTime();

                  if (isNewValueValid)
                    safeNewValue = format(newValueInDateFormat, "HH:mm");
                }

                setValue(name, text !== undefined ? text : safeNewValue);
              }}
              disabled={disabled}
              renderInput={(params) => (
                <TextField
                  margin="none"
                  variant="outlined"
                  size="small"
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
};

export default TimePicker;
